import ObjectId from 'bson-objectid';
import { Col, Modal, Text } from 'components';
import { Api, ws } from 'lib';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import ReactPlayer from 'react-player';
import { useDispatch, useSelector } from 'react-redux';

import { Chat, Header, Input, LocalVideo } from './components';

let interval;
const LiveStream = ({ data, localStream, visible, closeModal, isHost, modalBg }) => {
  const [watchingCount, setWatchingCount] = useState(0),
    stream = useSelector((state) => state.liveStream),
    user = useSelector((state) => state.user),
    { t } = useTranslation(),
    dispatch = useDispatch();

  useEffect(() => {
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    if (!visible) {
      clearInterval(interval);
      ws.send('leaveRoom', { roomId: stream?._id });
      dispatch({ type: 'RESET_LIVE_STREAM_STATE' });

      return;
    }

    if (!isHost) return joinStream();
  }, [visible]);

  useEffect(() => {
    if (!isHost || !stream) return;

    ws.send('joinRoom', { roomId: data._id, type: 'liveStream' });

    interval = setInterval(() => {
      getWatchingCount(data);
    }, 3000);
  }, [stream]);

  async function joinStream() {
    if (!data) return;

    const res = await Api.post('/streams/join', { roomId: data._id });

    if (!res) return;

    dispatch({
      type: 'SET_LIVE_STREAM',
      payload: res
    });

    ws.send('joinRoom', { roomId: data._id, type: 'liveStream' });

    getWatchingCount(res);
    interval = setInterval(() => {
      getWatchingCount(res);
    }, 3000);
  }

  async function endStream() {
    closeModal();
  }

  async function sendComment(text) {
    if (!text?.length) return;

    const data = {
      roomId: stream._id,
      comment: {
        _id: ObjectId().toString(),
        owner: {
          _id: user._id,
          name: user.name,
          username: user.username,
          avatar: user.avatar
        },
        text
      }
    };

    dispatch({
      type: 'NEW_LIVE_STREAM_MESSAGE',
      payload: data
    });

    ws.send('liveStreamMessage', data);
  }

  async function getWatchingCount(st) {
    const res = await Api.get(`/streams/getWatchingCount/${st._id}`);
    if (!res) return;

    setWatchingCount(res.count);
  }

  return (
    <Modal visible={visible} closeModal={() => null} modalBg={modalBg} selfContent>
      <Col
        bg="#000"
        ht="616px"
        wid="936px"
        noFlex
        hasRadius="24px"
        pos="relative"
        style={{ overflow: 'hidden' }}
        centerAll
      >
        <Header
          endStream={endStream}
          watchingCount={watchingCount}
          isHost={isHost}
          closeView={closeModal}
        />

        {!isHost && !!stream ? (
          stream?.status !== 'finished' ? (
            <ReactPlayer width="fit-content" height="inherit" url={data?.playbackUrl} playing />
          ) : (
            <Col centerAll center>
              <Text h2 col="#fff">
                {t('goLive.streamIsFinished')}
              </Text>
            </Col>
          )
        ) : (
          isHost && <LocalVideo localStream={localStream} data={data} />
        )}

        {stream && stream.status !== 'finished' && (
          <Col pos="absolute" bottom="0" wid="100%">
            <Chat messages={stream.messages} />

            <Input sendComment={sendComment} messages={stream.messages} />
          </Col>
        )}
      </Col>
    </Modal>
  );
};

export default LiveStream;
